import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useParams } from 'react-router-dom'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import { appAllGetFundrasing } from '../../store/fundrasing'
import ReceiptPDF from '../../components/filegenerate/filegenerate'
import PostPreview from '../../components/PostPreview/PostPreview'
import { contributionTypes } from '../../utils/getPostRole'

function TableFilter() {
	const dispatch = useDispatch()
	const params = useParams()

	const [page, setPage] = useState(params.page || 1)

	const [contributionType, setContributionType] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState('')

	const paginate = useSelector(state => state.fundrasingReducer.paginate)
	const isloder = useSelector(state => state?.facilitybookingReducer.isloder)

	const fundrasing = useSelector(state => state?.fundrasingReducer.fundrasing)

	useEffect(() => {
		dispatch(
			appAllGetFundrasing({
				page: page,
				limit: 10,
				paidtoportal: true,
				contributionType: contributionType || undefined,
				startDate: startDate || undefined,
				endDate: endDate || undefined,
			}),
		)
	}, [dispatch, page, contributionType, startDate, endDate])

	useEffect(() => {
		if (params.page && Number(params.page) !== page) {
			setPage(Number(params.page))
		}
	}, [params.page])

	return (
		<>
			{isloder && <PageLoader />}
			<div className="row mb-3">
				<div className="col-md-3">
					<select
						className="form-control"
						value={contributionType}
						onChange={e => setContributionType(e.target.value)}
					>
						<option value="">All Contribution Types</option>
						{contributionTypes.map((item, index) => (
							<option key={index} value={item.value}>
								{item.label}
							</option>
						))}
					</select>
				</div>

				<div className="col-md-3">
					<input
						type="date"
						className="form-control"
						value={startDate}
						onChange={e => setStartDate(e.target.value)}
					/>
				</div>

				<div className="col-md-3">
					<input
						type="date"
						className="form-control"
						value={endDate}
						onChange={e => setEndDate(e.target.value)}
					/>
				</div>

				<div className="col-md-3">
					<button
						className="btn btn-secondary w-100"
						onClick={() => {
							setContributionType('')
							setStartDate('')
							setEndDate('')
						}}
					>
						<em className="fas fa-redo"></em> Reset
					</button>
				</div>
			</div>
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>User</th>
									<th>Contribution Type</th>
									<th>Online/Offline</th>
									<th>Amount</th>
									<th>Payment Date</th>
									<th>Action</th>
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{fundrasing?.data &&
								fundrasing?.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<td>
													<PostPreview value={value?.userId?.profilePic || '/img/user.jpg'} />
													{value?.userId?.firstName} {value?.userId?.lastName}
													<br />
													<small>{value?.userId?.mobile}</small>
												</td>
												<td>
													<br />
													{value?.fundraisingType}
												</td>
												<td>
													{value.isOnline}
													{value?.isOnline === true ? (
														<span className="badge badge-primary">Online</span>
													) : (
														<span className="badge badge-primary">Offline</span>
													)}
												</td>
												<td>
													₹<span style={{ fontWeight: 'bold' }}>{value?.amount}</span> <br />
													{value?.offlinePaymentMode && (
														<small>Mode: {value?.offlinePaymentMode}</small>
													)}
												</td>
												<td>
													{new Date(value?.updatedAt).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td>
													<ReceiptPDF data={value?._id} />
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
